import type { AdminApp } from 'src/constants/adminApps.types'
import { hasAnyPermission } from 'src/utils/internalAccess/hasAnyPermission'

export const canAccessAdminApp = (app: AdminApp, permissions: string[]): boolean => {
  return hasAnyPermission(permissions, app.requiredAnyPermission)
}
